import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const messagingApi = createApi({
  reducerPath: "messaging/api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL_DEVELOP}`,
    // baseUrl: `https://customer-api.techsbookdemo.com/api/v1`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("techsbook_customer_portal_token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
        headers.set("time", String(Date.now()));
      }

      return headers;
    },
  }),
  keepUnusedDataFor: 0.0001,
  endpoints: (build) => ({
    getChats: build.mutation({
      query: (data) => ({
        url: `/conversations`,
        method: "GET",
        params: { page: data?.page, status: data?.status, search: data?.search },
      }),
    }),
    // getChatsSearch: build.mutation({
    //   query: (data) => ({
    //     url: `/conversations?search=${data?.search}`,
    //     method: "GET",
    //     params: { page: data?.page, status: data?.status },
    //   }),
    // }),
    getPresignedUrl: build.mutation({
      query: (data) => ({
        url: `/conversations/${data?.id}/get-presigned-url`,
        method: "GET",
        params: { file_extension: data?.file_extension },
      }),
    }),
    getTotalUnreadMessage: build.mutation({
      query: () => ({
        url: `/conversations/total-unread-message`,
        method: "GET",
      }),
    }),
    getNewChats: build.mutation({
      query: (data) => ({
        url: `/conversations/jobs`,
        method: "GET",
        params: { page: data?.page, search: data?.search },
      }),
    }),
    getMessaging: build.mutation({
      query: (body, page) => ({
        url: `/conversations/${body.id}/messages`,
        method: "GET",
        params: { page: body?.page },
      }),
    }),
    conversationJob: build.mutation({
      query: (body) => ({
        url: `/conversations/create/${body.id}`,
        method: "POST",
        body: body.body,
        formData: true,
      }),
    }),
    sendMessage: build.mutation({
      query: (body) => ({
        url: `/conversations/${body.body.userData.id}/send-message`,
        method: "POST",
        body: { content: body.body.content },
        formData: true,
      }),
    }),
    sendFiles: build.mutation({
      query: ({ body, id }) => ({
        url: `/conversations/${id}/send-message`,
        method: "POST",
        body,
        formData: true,
      }),
    }),
    markAsRead: build.mutation({
      query: (body) => ({
        url: `/conversations/${body.body.id}/message-read/${body.body.new_message.id}`,
        method: "POST",
        body: {},
        formData: true,
      }),
    }),
    updateName: build.mutation({
      query: ({params, body}) => ({
        url: `/conversations/title/${params}`,
        method: "POST",
        body: body,
        formData: true,
      }),
    }),
  }),
});

export const {
  useGetChatsMutation,
  useGetNewChatsMutation,
  useConversationJobMutation,
  useGetMessagingMutation,
  useSendMessageMutation,
  useSendFilesMutation,
  useMarkAsReadMutation,
  useGetTotalUnreadMessageMutation,
  useGetPresignedUrlMutation,
  useUpdateNameMutation,
} = messagingApi;
